import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Footer from '../Footer';

class PrivacyPolicyPage extends Component<{},{}>{

    constructor(props: any){
        super(props);
          this.state = {
              
          };
      }

      render(){
          return (
              <div id="about-us">
                 <header>
                    <ul>
                        <li><Link to="/Home">Home</Link></li>
                        <li><Link className="selected" to="/PrivacyPolicy">Privacy Policy</Link></li>
                        <li><Link to="/AboutUs">About Us</Link></li>
                        <li><Link to="/SummerDash">Summer Dash</Link></li>
                    </ul>
                </header>
                <body>
                    <div className="section">  
                        <p > Our Privacy Policy sets out how we collect, use and disclose “personal information” and other “non-personal information” <br/>
                             we have gathered about you about you in relation to our game “Cockpit”.</p>
                        <div id="policy">What Information do we collect?</div>
                        <p>
                            This app uses Google Ads which collects information, like IP address and device identifiers, whether you click or tap an <br/>
                            ad for a new game, whether you watch the ad or play a game frequently, whether others playing a game like the one you’re <br/>
                            playing have downloaded a particularly new game, and whether you download and install the new game you see advertised and <br/>
                            information regarding the delivery of ads and your interaction with them.
                        </p>

                        <div id="policy">How do we use the information?</div>
                        <p>
                            Google Ads which uses this information to predict the types of new games that you might like to download.
                        </p>
                        <div id="policy">What information do we share?</div>
                        <p>
                            Google Ads which shares this information with advertising publishers and attribution companies.
                        </p>
                        <div id="policy">How to opt out of personlized ads</div>
                        <p id="optout">
                            Android:<br/>
                            &emsp; 1. Find Google Settings in one of these places (depending on your device):<br/>
                            &emsp;&emsp; a. A separate app called Google Settings.<br/>
                            &emsp;&emsp; b. In your main Settings app, scroll down and tap Google.<br/>
                            &emsp; 2. Tap Ads<br/>
                            &emsp; 3. Switch on Opt out of interest-based ads.<br/>
                            <br/>
                            iOS:<br/>
                            &emsp; Devices with iOS use Apple’s Advertising Identifier. To learn more about your choices for use of this <br/>
                            &emsp; identifier, visit the Settings app on your device. 
                        </p>
                    </div>
                </body>
                <Footer></Footer>
              </div>
          )
      }
}

export default PrivacyPolicyPage;